export default __webpack_public_path__ + "static/girl-in-glasses-241cff764d173c72cb88b3e422cf66da.jpg";